_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupListMemRequestCtrl = ($scope ,$translate ,$filter ,$location ,GroupMemberService ) ->
  pageSize = 4
  listRequestCtrl = this
  listRequestCtrl.listRequest = []
  listRequestCtrl.currentPage = 0
  listRequestCtrl.isLoading = false
  listRequestCtrl.noResults = true
  listRequestCtrl.totalPages = 0

  listRequestCtrl.loadMore = ->
    listRequestCtrl.isLoading = true
    listRequestCtrl.currentPage++
    params =
      id : $scope.groupDetail.id
      page_size : pageSize
      page : listRequestCtrl.currentPage
      status : 'pending'
    GroupMemberService.listMemRequest(params)
    .then (data) ->
      listRequestCtrl.listRequest = _.union(listRequestCtrl.listRequest ,data.members)
      listRequestCtrl.totalPages = data.total_pages
      listRequestCtrl.noResults = listRequestCtrl.listRequest.length == 0
      $scope.$emit 'gnp.group.request.changed', data.total
    .finally ->
      listRequestCtrl.isLoading = false

  refeshPage = ->
    listRequestCtrl.listRequest = []
    listRequestCtrl.currentPage = 0
    listRequestCtrl.isLoading = false
    listRequestCtrl.noResults = true
    listRequestCtrl.totalPages = 0
    listRequestCtrl.loadMore()

  listRequestCtrl.hasMore = ->
    listRequestCtrl.noResults == false && listRequestCtrl.currentPage < listRequestCtrl.totalPages

  listRequestCtrl.processRequest = (request , status) ->
    params =
      id : request.group_entry_id
      status: status
    GroupMemberService.processMemRequest(params).then (resp) ->
      refeshPage()

  listRequestCtrl.displayUserName = (fName , lName) ->
    fName = fName ? ''
    lName = lName ? ''
    if fName + lName == ''
      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')

    if /^ja/i.test $translate.preferredLanguage()
      return lName + " " + fName
    return fName + " " + lName

  listRequestCtrl.displayNumberRequest = (number) ->
    if number > 0
      return $filter('formatString')($filter('translate')('_GROUP_MEMBERS.NUMBER_REQUEST') , number)
    $filter('translate')('_GROUP_MEMBERS.NO_NEW_REQUEST')

  $scope.getTextOfAvatar = (member) ->
    $avatarElement = $(".avatar-for-#{member.id} .avatar-image-text:not(.is-small)")
    if member.display_text_avatar.length == 1
      $avatarElement.removeClass('two-characters')
      $avatarElement.addClass('one-character')
    else
      $avatarElement.removeClass('one-character')
      $avatarElement.addClass('two-characters')
    member.display_text_avatar

  $scope.isAvatarColor = (member) ->
    member.avatar_image_path?.indexOf('avatar_color') > -1

  listRequestCtrl.loadMore()
  listRequestCtrl

GroupListMemRequestCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  '$location'
  'GroupMemberService'
]

module.exports = GroupListMemRequestCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-list-mem-request-controller.coffee